// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"248":"3ebb679e","391":"c5d20498","643":"9f7c26b8","840":"3b0d059a"}[chunkId] + ".chunk.css";
};